
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import 'react';
import { hoverContainer } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import { m } from '../../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs.js';

var hoverContainerVariants = {
  rest: {
    opacity: 0
  },
  hover: {
    opacity: 1
  }
};
var hoverContent = {
  rest: {
    display: "none"
  },
  hover: {
    display: "block"
  }
};
var Hover = function Hover(_ref) {
  var _ref$transparent = _ref.transparent,
    transparent = _ref$transparent === void 0 ? false : _ref$transparent,
    className = _ref.className,
    children = _ref.children;
  return jsx(m.div, {
    transition: {
      duration: 0.15,
      ease: "easeIn"
    },
    variants: hoverContainerVariants,
    css: function css(theme) {
      return hoverContainer(theme, {
        transparent: transparent
      });
    },
    className: className,
    "data-testid": "card-hover"
  }, jsx(m.div, {
    className: "hover-wrapper",
    variants: hoverContent
  }, children));
};

export { Hover as default };
//# sourceMappingURL=Hover.js.map
